export const constants = {
  tooltips: {
    upgradePlan: 'Upgrade your plan to access this content.',
  },
  // Added existing journals from cases
  journals: [
    'CLR',
    'KLR',
    'LHC',
    'MLD',
    'NLR',
    'PCRLJ',
    'PCTLR',
    'PLC',
    'PLD',
    'PLJ',
    'PSC',
    'PSC CIV',
    'PSC CRI',
    'PTCL',
    'PTD',
    'SCMR',
    'SCR',
    'TAX',
    'YLR'
  ],
  pageSize: localStorage.getItem('role') === 'free' ? '20' : '10',
  richTextEditorOptions: {
    options: ['inline', 'list', 'textAlign', 'history'], inline: {
      options: ['bold', 'italic', 'underline', 'strikethrough'],
    },
  },
  regexes: {
    citationSearch: new RegExp(/((\d{4})(.?)((P.?T.?D)|(P.?C.?R.?.?.?L.?J)|(C.?L.?D)|(C.?L.?C)|(M.?L.?D)|(P.?T.?C.?L)|(S.?C.?M.?R)|(Y.?L.?R)|(L.?H.?C)|(P.?C.?T.?L.?R)|(.?P.?L.?C.?))(.?)((.?C.?S.?.?)|(.?Trib.?.?))?(.?)(\d{1,4}))|(((N.?L.?R.?)|(.?K.?L.?R.?)|(P.?L.?J.?)|(PLD|P(.?)L(.?)D)|(P.?C.?R.?.?.?L.?J)|(C.?L.?D)|(C.?L.?C)|(M.?L.?D)|(P.?T.?C.?L)|(S.?C.?M.?R)|(Y.?L.?R)|(L.?H.?C)|(P.?C.?T.?L.?R))(.?)(\d{4})(.?)(.?W.?.?P.?.?)?(.?)(Civil|Criminal|Labour|Revenue|Service.?|Tax|Civil Case.?|Labour and Service.? Case.?|Labour & Service.? Case.?|Criminal Case.?|Revenue Case.?|Shariat Case.?|Supreme Court Case.?|Tax and Corporate Case.?|Tax and Custom.? Case.?|Tax and Custom.?|Tax & Custom.?|S.?C.?|Supreme Court|High Court|Lahore|.?Lah..?|SHC|.?Sh.?C.?.?|Sindh|Kar.|Karachi|West Pakistan|Peshawar|Pesh.|F.?C.?|Federal Court|Dacca|Islamabad|Quetta|.?Rev.?.?|Privy Council|Baghdad-ul-Jadid)?(.?)(.?Pak.?.?|.?AJ.?K.?)?(.?)(\d{1,4}))/gi),
  },
  images: {
    EastLawLogo: require("./assets/landing/logo-grey-bg.svg").default,
    EastLawLogo2: require("./assets/landing/logo.svg").default,
    JazzCashLogo: require("./assets/jazzcash-logo.png"),
    MasterCardLogo: require("./assets/mastercard-logo.svg").default,
    VizaCardLogo: require("./assets/visa-logo.svg").default,
    Facebook: require("./assets/landing/facebook-square-brands.svg").default,
    LinkedId: require("./assets/landing/linkedin-brands.svg").default,
    Twitter: require("./assets/landing/twitter-square-brands.svg").default,
    Instagram: require("./assets/landing/instagram-square-brands.svg").default,
    Waves: require("./assets/landing/waves.svg").default,
    Arrow: require("./assets/landing/Arrow Right.svg").default,
    Mobile: require("./assets/landing/undraw_judge_katerina_limpitsouni_ny-1-q.svg").default,
  },
  svgs: {
    whiteBalance: require('./assets/svgs/balance-white.svg').default,
  },
  statuteTypes: [
    { id: 'primary', title: 'Primary' },
    { id: 'secondary', title: 'Secondary' },
    { id: 'bills', title: 'Bills' },
    { id: 'amendments', title: 'Amendments' },
  ],
  statuteSubGroups: [
    { title: 'Punjab' },
    { title: 'Federal' },
    { title: 'Sindh' },
    { title: 'Khyber Pakhtunkhwa' },
    { title: 'Balochistan' },
    { title: 'Gilgit Baltistan' },
    { title: 'AZAD JAMMU AND KASHMIR' },
  ],
  statuteGroups: [
    { title: 'Provincial' },
    { title: 'Federal' },
  ],
};